import React from 'react';

const CreateBoard = ({ handleClose, show, onSubmit, handleInput }) => {

  const showHideClassName = show ? 'modal show' : 'modal hide';

  return (
    <div className={showHideClassName}>
      <div className="content create">
        <button className="close" onClick={handleClose}>
          <i className="fa fa-angle-right"></i>
          <i className="fa fa-angle-left"></i>
        </button>
        <form onSubmit={onSubmit}>
          <h3 className="title">Create Stack</h3>
          <br/>
          <p>
            <input type="text" id="title" name="title" placeholder="What's it called?" onChange={handleInput} />
          </p>
          <p>
            <button className="btn" type="submit" >Create</button>
          </p>
        </form>
      </div>
    </div>
  );
}

export default CreateBoard;


// WEBPACK FOOTER //
// ./src/components/CreateBoard.js